// extracted by mini-css-extract-plugin
export default {"root":"Yvcl9zym0SwS63E5G0as","closeButton":"AN6VtoAFpHkTlPCEGqP_","getButton":"PvwFqx2_TfjU6P639tPH"};